import { CommercetoolsProject, CustomLink, Media } from "@/types";

export enum EventLaunchType {
  TEASER = "Teaser",
  REVEAL = "Reveal",
  LAUNCH = "Launch",
  POST_LAUNCH = "Post Launch",
  RESERVED = "Reserved",
  RESTRICTED = "Restricted",
  SOLD_OUT = "Sold Out",
  COMMUNITY = "Community",
}
export type EventLaunchKey = keyof typeof EventLaunchType;

export type Logo = {
  src: string;
  alt?: string;
};

interface LabelsProps {
  mobile?: Record<string, string>;
  desktop: Record<string, string>;
}

export type StickyBarProps = {
  communityLogo: Logo;
  unitBedroom?: {
    min: string | number;
    max: string | number;
  };
  projectTypes: string;
  projectPrice?: number;
  status: EventLaunchType;
  productId: string;
  sellable?: boolean;
  projectName?: string;
  projectCity?: string;
  title?: string;
  description?: string;
  isProject?: boolean;
  projectStatus?: string;
  typesProject?: string;
  serverSideCookieCurrency?: string;
  currencyFromApiRes?: string;
  fallbackTitle?: string;
  fallbackDescription?: string;
  leadFormPageLocation?: string;
  isInventoryAvaialable?: boolean;
  videocontent?: Record<string, any>;
  projectdatalayer?: boolean;
  projectData?: any;
  projectPDF?: any;
  microcopyComponent?: any;
  availability?: boolean;
};

export type StickyBarEditorialProps = {
  entry: StickyBarEditorialEntry;
  projectTypes: string;
  unitBedroom?: {
    min: string | number | undefined;
    max: string | number | undefined;
  };
  projectPrice: number;
  projectName?: string;
  projectCity?: string;
  projectStatus?: string;
};

export type StickyBarEditorialEntry = {
  title: string;
  subtitle: string | React.ReactNode;
  ctaPrimary: CustomLink;
  ctaSecondary?: CustomLink;
  addToFavorites?: CommercetoolsProject;
  logo?: Media;
  // Optional event fields supplied by the CMS when a CTA link is the "add-to-calendar" token.
  eventDate?: string;
  eventLocation?: string;
  description?: string;
};

export type MicrocopyComponentProps = {
  id: string;
  type: "microcopyComponent";
  title: string;
  subTitle: string;
  link: any;
  isStickybar?: boolean;
  isCloseable?: boolean;
  // isLinkOnly?: boolean;
  backgroundColor?: string;
  linkLabel?: string;
  resetMicrocopyState?: () => void;
};
